import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import FeedbackButton from "./components/FeedbackButton";
import SiteIdentityBanner from "./components/SiteIdentityBanner";
import EducationalBanner from "./components/EducationalBanner";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import ChronicDiseaseDashboard from "./pages/ChronicDiseaseDashboard";
import VaccineIntelligence from "./pages/VaccineIntelligence";
import YouInTheData from "./pages/YouInTheData";
import PublicHealth101 from "./pages/PublicHealth101";
import AutoimmuneDiseases from "./pages/AutoimmuneDiseases";

function App() {
  useEffect(() => {
    const removeBadge = () => {
      document.querySelectorAll('a[href*="emergent"], div[class*="emergent"], div[class*="Emergent"]').forEach(el => {
        el.style.display = 'none';
      });
      document.querySelectorAll('div[style]').forEach(el => {
        const s = el.getAttribute('style') || '';
        if (s.includes('fixed') && s.includes('bottom') && s.includes('right') && el.textContent?.includes('Emergent')) {
          el.style.display = 'none';
        }
      });
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen bg-[radial-gradient(circle_at_top,_rgba(181,126,220,0.16),_transparent_30%),linear-gradient(180deg,_#f8f5ff_0%,_#ffffff_18%,_#f8fafc_100%)] flex flex-col" data-testid="app-container">
        <EducationalBanner />
        <Navigation />
        <SiteIdentityBanner />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chronic-disease" element={<ChronicDiseaseDashboard />} />
            <Route path="/autoimmune" element={<AutoimmuneDiseases />} />
            <Route path="/vaccines" element={<VaccineIntelligence />} />
            <Route path="/risk" element={<YouInTheData />} />
            <Route path="/learn" element={<PublicHealth101 />} />
          </Routes>
        </main>
        <FeedbackButton />
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
